import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface I18nResource {
  prefix: string;
  suffix: string;
}

// Créé par la `useFactory` du `TranslateLoader` (app.config.ts), donc dans un contexte d'injection.
export class MultiTranslateHttpLoader implements TranslateLoader {
  private readonly http = inject(HttpClient);

  constructor(private resources: I18nResource[]) {}

  getTranslation(lang: string): Observable<any> {
    const requests = this.resources.map((resource) => {
      return this.http.get(`${resource.prefix}${lang}${resource.suffix}`).pipe(
        catchError(() => {
          console.warn(
            `Could not load translations from ${resource.prefix}${lang}${resource.suffix}`,
          );
          return of({});
        }),
      );
    });

    return forkJoin(requests).pipe(
      map((response) => {
        return response.reduce((a, b) => {
          return { ...a, ...b };
        }, {});
      }),
    );
  }
}
